var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTextTooltip',{attrs:{"tooltipText":"This step can't be edited"}},[_c('FlowTreeVirtualBlock',_vm._g(_vm._b({attrs:{"blockData":_vm.blockData,"appData":_vm.appData}},'FlowTreeVirtualBlock',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }